import { makeContextModule } from '@cian/react-utils';

import { createSelector } from '@reduxjs/toolkit';

import type { IOfferSchema } from 'shared/repositories/commercial-search-offers/entities/offer/OfferSchema';
import type { IOfferDataSchema } from 'shared/repositories/commercial-search-offers/entities/offer_data/OfferDataSchema';
import type { IPublisherSchema } from 'shared/repositories/commercial-search-offers/entities/publisher/PublisherSchema';
import type { CardContextData } from 'shared/types/CardContextData';

export const {
  Context: { Provider: CardContextProvider, Consumer: CardContextConsumer },
  useContext: useCardContext,
  withContext: withCardContext,
} = makeContextModule<CardContextData>({
  contextName: 'CardContext',
});

const cardContextDataSelector = (state: CardContextData): CardContextData => state;

export const cardOfferSelector = createSelector(cardContextDataSelector, state => state.offer);
export function useCardOfferContext(): IOfferSchema {
  return cardOfferSelector(useCardContext());
}

export const cardOfferDataSelector = createSelector(cardOfferSelector, state => state.data);
export function useCardOfferDataContext(): IOfferDataSchema {
  return cardOfferDataSelector(useCardContext());
}

export const cardOfferPublisherSelector = createSelector(cardOfferSelector, state => state.publisher);
export function useCardOfferPublisherContext(): IPublisherSchema {
  return cardOfferPublisherSelector(useCardContext());
}

export const cardOfferIsMultiSelector = createSelector(cardOfferDataSelector, state => state.areaParts);
export function useCardOfferIsMulti(): boolean {
  const areaParts = cardOfferIsMultiSelector(useCardContext());

  return !!areaParts;
}

export const cardOfferExtendedPropertiesSelector = createSelector(
  cardOfferDataSelector,
  state => state.extendedProperties.offerServices,
);
export function useCardOfferIsTop3(): boolean {
  const offerServices = cardOfferExtendedPropertiesSelector(useCardContext());

  return !!offerServices?.isTop3;
}
